import { motion } from "framer-motion";
import { Reveal, Lines, SectionTag, EASE } from "../site/Motion";

const STATS = [
  { value: "1009", unit: "mm", label: "Larghezza carrozzeria" },
  { value: "2", unit: "posti", label: "In tandem ONE+1™" },
  { value: "2529", unit: "mm", label: "Lunghezza" },
];

export function OnePlusOne() {
  return (
    <section id="one-plus-one" data-testid="oneplusone-section" className="relative overflow-hidden border-t border-white/10 bg-ink py-28 sm:py-40">
      <div className="pointer-events-none absolute -right-20 top-10 select-none font-display text-[26rem] font-black leading-none text-white/[0.025] max-lg:hidden" aria-hidden="true">
        +1
      </div>
      <div className="mx-auto max-w-[1600px] px-5 sm:px-10">
        <SectionTag index="03" label="Architettura tandem" />
        <div className="mt-10 grid items-center gap-16 lg:grid-cols-2">
          <div>
            <p className="font-mono text-xs uppercase tracking-[0.25em] text-swapa-yellow">ONE+1™</p>
            <h2 className="mt-4 font-display font-extrabold uppercase leading-[0.92] tracking-tight">
              <Lines lines={["Two seats.", "One line."]} className="text-4xl text-white sm:text-6xl lg:text-7xl" />
            </h2>
            <Reveal delay={0.3}>
              <p className="mt-8 font-display text-2xl font-bold uppercase tracking-tight text-zinc-400 sm:text-3xl">
                Less width. <span className="text-swapa-yellow">More city.</span>
              </p>
              <p className="mt-6 max-w-lg text-base leading-relaxed text-zinc-400">
                Guida e passeggero viaggiano uno dietro l'altro, non uno accanto all'altra.
                L'abitacolo tandem riduce la larghezza e rende SWAPA naturalmente a proprio agio
                negli spazi densi della città: manovre, scorciatoie urbane, parcheggi compatti.
              </p>
            </Reveal>
            <div className="mt-12 grid grid-cols-3 gap-6">
              {STATS.map((s, i) => (
                <Reveal key={s.label} delay={0.15 * i}>
                  <p className="font-mono text-3xl font-semibold text-white sm:text-4xl">
                    {s.value}
                    <span className="ml-1 text-xs uppercase text-swapa-yellow">{s.unit}</span>
                  </p>
                  <p className="mt-2 font-mono text-[10px] uppercase tracking-[0.18em] text-zinc-500">{s.label}</p>
                </Reveal>
              ))}
            </div>
          </div>

          <div className="flex flex-col items-center gap-12">
            <Reveal y={50} className="w-full">
              <div className="relative overflow-hidden border border-white/10">
                <img
                  src="/assets/oneplus-interior.webp"
                  alt="Abitacolo tandem ONE+1 visto dall'alto: due sedili in linea"
                  className="w-full object-cover"
                  loading="lazy"
                />
                <span className="absolute left-4 top-4 border border-white/15 bg-black/60 px-3 py-1.5 font-mono text-[9px] uppercase tracking-[0.2em] text-swapa-yellow backdrop-blur-sm">
                  Vista dall'alto — ONE+1™
                </span>
              </div>
            </Reveal>
            <div className="w-full max-w-md space-y-5">
              <div>
                <div className="flex justify-between font-mono text-[10px] uppercase tracking-[0.18em] text-zinc-500">
                  <span>Auto tradizionale</span><span>~1.800 mm</span>
                </div>
                <div className="mt-2 h-2 w-full bg-white/10" />
              </div>
              <div>
                <div className="flex justify-between font-mono text-[10px] uppercase tracking-[0.18em] text-swapa-yellow">
                  <span>Swapa</span><span>1.009 mm</span>
                </div>
                <motion.div
                  className="mt-2 h-2 bg-swapa-yellow"
                  initial={{ width: "100%" }}
                  whileInView={{ width: "56%" }}
                  viewport={{ once: true }}
                  transition={{ duration: 1.4, ease: EASE }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
